import { render } from "./GTINLabelSetupPage.vue?vue&type=template&id=26ba0d46&scoped=true"
import script from "./GTINLabelSetupPage.vue?vue&type=script&lang=js"
export * from "./GTINLabelSetupPage.vue?vue&type=script&lang=js"

import "./GTINLabelSetupPage.vue?vue&type=style&index=0&id=26ba0d46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ba0d46"]])

export default __exports__